export function stringToColor(value) {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    let partialColor = (hash >> (i * 8)) & 0xFF;
    color += ('00' + partialColor.toString(16)).substr(-2);
  }
  return color;
}

export function groupMessagesByChannel(messages) {
  return messages.reduce((messagesByChannel, message) => {
    if (!messagesByChannel[message.branch]) {
      messagesByChannel[message.branch] = [];
    }
    messagesByChannel[message.branch].push(message);
    return messagesByChannel;
  }, {})
}